export default __webpack_public_path__ + "936b20db6dc16c04a7b1ef9d70c592f5.png";